import api from '@/api'
import user from './user'
import units from './units'
import products from './products'
import restaurants from './restaurants'
import providers from './providers'

export default {
  namespaced: true,

  modules: {
    user,
    units,
    products,
    restaurants,
    providers
  },

  state: {
    token: null,
    role: '',
    employment: '',
    permissions: null
  },

  actions: {
    signIn: async function (ctx, payload) {
      const response = await api.post(`/v1/signin`, payload)

      ctx.commit('setToken', response.jwt)
      ctx.commit('user/set', response.user)

      await ctx.dispatch('loadLoginData')
    },
    signOut: async function (ctx) {
      await ctx.dispatch('resetLogin')
      ctx.commit('user/reset')
      ctx.commit('resetToken')
      ctx.commit('resetRole')
      ctx.commit('resetEmployment')
      ctx.commit('resetUserData')
    },
    subscribeUnitsChannel: async function (ctx) {
      const channel = await this._vm.$pusher.subscribe('units-channel')
      channel.bind('unit-created', function (data) {
        ctx.commit('units/add', data)
      })
      channel.bind('unit-updated', function (data) {
        ctx.commit('units/update', data)
      })
      channel.bind('unit-deleted', function (data) {
        ctx.commit('units/delete', data)
      })
    },
    unsubscribeUnitsChannel: async function (ctx) {
      await this._vm.$pusher.unsubscribe('units-channel')
    },
    resetLogin: async function (ctx) {
      await ctx.dispatch('unsubscribeUnitsChannel')
      await ctx.dispatch('currentRestaurant/unsubscribeRestaurantChannel', null, { root: true })
      ctx.commit('units/reset')
      ctx.commit('restaurants/reset')
      ctx.commit('providers/reset')
      await ctx.dispatch('currentRestaurant/reset', null, { root: true })
      await ctx.dispatch('currentProvider/reset', null, { root: true })
      ctx.commit('resetPermissions')
      ctx.commit('user/reset')
      ctx.commit('resetUserData')
    },
    refreshLogin: async function (ctx) {
      await ctx.dispatch('resetLogin')
      ctx.commit('user/reset')
      ctx.commit('resetUserData')

      const response = await api.post(`/v1/refresh-token`)

      ctx.commit('setToken', response.jwt)
      ctx.commit('user/set', response.user)

      await ctx.dispatch('loadLoginData')
    },
    loadLoginData: async function (ctx) {
      if (ctx.rootState.userProvider) {
        await ctx.dispatch('loadProviders')
      } else {
        await ctx.dispatch('loadRestaurants')
      }
      const unitsParams = {
        select: '_id name'
      }
      ctx.dispatch('units/get', unitsParams)
    },
    loadRestaurants: async function (ctx) {
      const restaurantsParams = {
        select: '_id name fees wansoftId country useWhiteList allowedProviders deliveryAddresses isLive employment balanceLimit'
      }
      await ctx.dispatch('restaurants/get', restaurantsParams)
    },
    loadProviders: async function (ctx) {
      const providersParams = {
        select: '_id name onboarded extendLayout'
      }
      await ctx.dispatch('providers/get', providersParams)
    }
  },

  mutations: {
    setToken: function (state, token) {
      state.token = token
    },
    resetToken: function (state) {
      state.token = null
    },
    setRole: function (state, role) {
      state.role = role
    },
    resetRole: function (state) {
      state.role = ''
    },
    setEmployment: function (state, employment) {
      state.employment = employment
    },
    resetEmployment: function (state) {
      state.employment = ''
    },
    setPermissions: function (state, permissions) {
      state.permissions = permissions
    },
    resetPermissions: function (state) {
      state.permissions = null
    },
    resetUserData: function (state) {
      state.user = {
        firstName: '',
        lastName: '',
        email: '',
        language: '',
        phone: ''
      }
    }
  }
}
